(() => {
  const SELECTOR = '[data-ct-scroll-carousel]';

  class CTScrollCarousel {
    constructor(root) {
      this.root = root;
      this.viewport = root.querySelector('[data-ct-carousel-viewport]');
      this.previousButton = root.querySelector('[data-ct-carousel-prev]');
      this.nextButton = root.querySelector('[data-ct-carousel-next]');

      if (!this.viewport || !this.previousButton || !this.nextButton) return;

      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);

      this.previousButton.addEventListener('click', () => {
        this.scroll(-1);
      });

      this.nextButton.addEventListener('click', () => {
        this.scroll(1);
      });

      this.viewport.addEventListener('scroll', this.onScroll, {
        passive: true,
      });

      window.addEventListener('resize', this.onResize);

      this.updateButtons();
    }

    getScrollAmount() {
      const firstItem = this.viewport.firstElementChild;

      if (!firstItem) {
        return this.viewport.clientWidth * 0.8;
      }

      const itemWidth = firstItem.getBoundingClientRect().width;
      const styles = window.getComputedStyle(this.viewport);
      const gap =
        Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;

      return itemWidth + gap;
    }

    scroll(direction) {
      this.viewport.scrollBy({
        left: direction * this.getScrollAmount(),
        behavior: 'smooth',
      });
    }

    onScroll() {
      window.requestAnimationFrame(() => {
        this.updateButtons();
      });
    }

    onResize() {
      this.updateButtons();
    }

    updateButtons() {
      const maximumScroll =
        this.viewport.scrollWidth - this.viewport.clientWidth;

      const hasOverflow = maximumScroll > 2;
      const isAtStart = this.viewport.scrollLeft <= 2;
      const isAtEnd =
        this.viewport.scrollLeft >= maximumScroll - 2;

      this.previousButton.hidden = !hasOverflow || isAtStart;
      this.nextButton.hidden = !hasOverflow || isAtEnd;
    }
  }

  const initialize = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach((carousel) => {
      if (carousel.dataset.ctCarouselReady === 'true') return;

      carousel.dataset.ctCarouselReady = 'true';
      new CTScrollCarousel(carousel);
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    initialize();
  });

  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target);
  });
})();